// TODO: deprecated once the support flow is live on every portal, then remove this module and its checks
const SUPPORT_FLOW_PORTALS = ['liveflight']

export const is_support_flow_enabled = () => SUPPORT_FLOW_PORTALS.includes(process.env.VUE_APP_NAME)
